import {
  Geocode,
  GeocodeCoords
} from '../types';

class GoogleGeocoder {
  private _geocoder: google.maps.Geocoder;

  constructor() {
    this._geocoder = new google.maps.Geocoder();
  }

  geocodeCoords: GeocodeCoords = (coords) => new Promise((resolve) => {
    const latlng = new google.maps.LatLng(coords);
    this._geocoder.geocode(
      { location: latlng },
      (result = []) => {
        const [{ formatted_address: address = '' } = {}] = result || [];
        resolve({ address });
      }
    );
  });

  geocode: Geocode = (request) => this._geocoder.geocode(request);
}

export default GoogleGeocoder;
